/**
 * @param   {String} entityType
 * @returns {Function}
 */
export default function findEntitiesByType(entityType) {
  return (contentBlock, callback, contentState) =>
    contentBlock.findEntityRanges(
      character =>
        character.getEntity() !== null &&
        contentState.getEntity(character.getEntity()).getType() === entityType,
      callback,
    );
}
